import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import { catchError,map } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable, of, throwError } from 'rxjs';
import * as globalConstant from './../global_constant';

@Injectable({
  providedIn: 'root'
})
export class PageSectionService {
  apiDomain			=	globalConstant.DOMAIN;
  pageDataApi		=	globalConstant.PAGE_DATA_API;
  PageSectionApi	=	globalConstant.PAGE_SECTION_API;
  ArticleApi		=	globalConstant.ARTICLE_API;
  siteRequestFrom	=	globalConstant.SITE_REQUEST_FROM;
  expGiftCertificateApi	=	globalConstant.EXP_GIFT_CERTIFICATE;
  constructor(public router: Router,private http: HttpClient) {    

  } 

  //get page sections. 
  page_sections(formData){

	const httpOptions = {
      headers: new HttpHeaders({
        //'Vebo-Key': 'sdfsf456s1df21sfs89f7sfsfs23f12s3f4s',
        'Content-Type': 'application/json',
        'requestFrom':this.siteRequestFrom
      })
    };
    return this.http.post<any>(this.apiDomain+this.PageSectionApi,formData,httpOptions).pipe(map(res=>{
      return res;
    }),
    catchError(err => {
      return err.error;
    }));
  }
  
 //get page sections. 
 gift_certificate_sections(formData){

	const httpOptions = {
      headers: new HttpHeaders({
        //'Vebo-Key': 'sdfsf456s1df21sfs89f7sfsfs23f12s3f4s',
        'Content-Type': 'application/json',
        'requestFrom':this.siteRequestFrom
      })
    };
    return this.http.post<any>(this.apiDomain+this.expGiftCertificateApi,formData,httpOptions).pipe(map(res=>{
      return res;
    }),
    catchError(err => {
      return err.error;
    }));
  }

   get_page_data(formData){ 

        const httpOptions = {
            headers: new HttpHeaders({
              //'Vebo-Key': 'sdfsf456s1df21sfs89f7sfsfs23f12s3f4s',
              'Content-Type': 'application/json',
              'requestFrom':this.siteRequestFrom
            })
          };
          return this.http.post<any>(this.apiDomain+this.pageDataApi,formData,httpOptions).pipe(map(res=>{
            return res;
          }),
          catchError(err => {
            return err.error;
          }));
    }

  get_article(){

    const httpOptions = {
        headers: new HttpHeaders({
          //'Vebo-Key': 'sdfsf456s1df21sfs89f7sfsfs23f12s3f4s',
          //'Content-Type': 'application/x-www-form-urlencoded',
          'requestFrom':this.siteRequestFrom
        })
      };
      return this.http.get<any>(this.apiDomain+this.ArticleApi,httpOptions).pipe(map(res=>{
        return res;
      }),
      catchError(err => {
        return err.error;
      }));
    }
  
}




